<nz-layout>
  <!-- <nz-header class="section-header">
    {{ "Departmental Questionnaires" | translate }}
  </nz-header> -->
  <nz-content>
    <!-- <app-social-history-questonaire /> -->

    @if (activeDepartmentModule; as cm) {
      @if (cm.path === componentPaths.speechTherapyQuestionnaire) {
        <app-speech-therapy-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
      @if (cm.path === componentPaths.physiotherapyQuestionnaire) {
        <app-physiotherapy-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
    }
  </nz-content>
</nz-layout>
